import { CFormCheck, CTableDataCell, CTableRow } from "@coreui/react";
import { useCallback, useEffect, useState } from "react";
import DeleteIcon from "../../components/icons/DeleteIcon";
import EditIcon from "../../components/icons/EditIcon";
import PromptModal from "../../components/modals/PromptModal";
import { colors } from "../../config/theme";
import { tdStyle } from "../../helpers/constants";
import { IconAction } from "../../helpers/general";
import { useReward } from "../../hooks/useReward";

interface Props {
  reward: Reward;
  onSelect?: (id: string, state: "add" | "remove") => void;
}

export default function RewardListRow({ reward, onSelect }: Props) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { deleteReward } = useReward();

  const toggle = useCallback(
    (checked: boolean) => {
      setIsChecked(checked);
      onSelect?.(reward.id, checked ? "add" : "remove");
    },
    [onSelect, reward.id],
  );

  // A row that unmounts (page change, search, filter) must not stay selected
  useEffect(() => () => onSelect?.(reward.id, "remove"), [onSelect, reward.id]);

  return (
    <>
      <CTableRow
        style={{
          backgroundColor: isChecked ? "rgba(240,129,63,0.06)" : undefined,
          boxShadow: isChecked ? `inset 3px 0 0 ${colors.primary}` : undefined,
        }}
      >
        <CTableDataCell style={tdStyle}>
          <div className="d-flex align-items-center gap-3">
            <CFormCheck
              checked={isChecked}
              onChange={(e) => toggle(e.target.checked)}
            />
            <img
              src={reward.picture}
              alt={reward.title}
              width={40}
              height={40}
              className="rounded-circle object-fit-cover"
            />
          </div>
        </CTableDataCell>

        <CTableDataCell style={tdStyle}>
          <span className="fw-semibold">{reward.title}</span>
        </CTableDataCell>

        <CTableDataCell style={tdStyle}>{reward.type}</CTableDataCell>

        <CTableDataCell style={tdStyle}>{reward.pointsRequired}</CTableDataCell>

        <CTableDataCell style={tdStyle}>
          {reward.isActive ? "✅" : "❌"}
        </CTableDataCell>

        <CTableDataCell style={tdStyle}>
          {reward.isReusable ? "♻️" : "❌"}
        </CTableDataCell>

        <CTableDataCell style={tdStyle}>
          {reward.isFeatured ? "✅" : "❌"}
        </CTableDataCell>

        <CTableDataCell style={tdStyle}>
          <div className="d-flex align-items-center justify-content-end gap-2">
            <IconAction title="Modifier" to={`/rewards/${reward.id}`}>
              <EditIcon width="16" height="16" fill={colors.secondary} />
            </IconAction>
            <IconAction
              title="Supprimer"
              danger
              onClick={() => setShowModal(true)}
            >
              <DeleteIcon width="18" height="18" fill={colors.primary} />
            </IconAction>
          </div>
        </CTableDataCell>
      </CTableRow>

      <PromptModal
        open={showModal}
        onAccept={() => {
          deleteReward(reward.id);
          setShowModal(false);
        }}
        onClose={() => setShowModal(false)}
      />
    </>
  );
}
